import React from 'react';

import { FormProvider, useForm } from 'react-hook-form';

import { LoadingType, setAccount, setLoadingState, setSignInStep, SignInStep } from 'prequalificationV2/actions';
import AccountForm, { AccountFormData } from 'prequalificationV2/components/AccountForm/AccountForm';
import FormHeader from 'prequalificationV2/components/FormHeader';
import Loader from 'components/Loader';
import { useAppDispatch } from 'prequalificationV2/hooks/useAppDispatch';
import { useAppSelector } from 'prequalificationV2/hooks/useAppSelector';
import { authApi } from 'api/auth/AuthApi';

import styles from './ForgotPassword.module.scss';

const ForgotPassword = () => {
  const dispatch = useAppDispatch();

  const loading = useAppSelector((state) => state.loading[LoadingType.GetData]);
  const { emailError } = useAppSelector((state) => state.account);

  const handleSubmit = async (data: AccountFormData) => {
    if (data.email) {
      dispatch(setLoadingState({ type: LoadingType.GetData, loading: true }));
      dispatch(setAccount({ email: data.email }));
      dispatch(setSignInStep(SignInStep.SentResetPasswordLink));
      await authApi.requestResetPassword(data.email!);
      dispatch(setLoadingState({ type: LoadingType.GetData, loading: false }));
    }
  };

  const formMethods = useForm({
    defaultValues: {
      email: '',
      password: '',
    },
  });

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div>
          <FormHeader title="Forgot Password?" subtitle="Please enter your email" />
          <FormProvider {...formMethods}>
            <AccountForm
              showEmailField
              buttonLabel="Send Verification Code"
              emailError={emailError}
              onSubmit={handleSubmit}
              isNextButton
              backButton={SignInStep.SignIn}
              buttonRowClassname={styles.buttonRow}
            />
          </FormProvider>
        </div>
      )}
    </>
  );
};

export default ForgotPassword;
